import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, tap} from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import {environment} from "../../environments/environment";
import {UserInterface} from "../types/user/user.interface";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient, public jwtHelper: JwtHelperService) {}

  checkEmail(email: string) {
    return this.http.post(`users/check-email`, {email});
  }

  register(user: any): Observable<any> {
    return this.http.post(`users/register`, user).pipe(
      tap((response: any) => {
        this.setSession(response);
      })
    );
  }

  login(credentials: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/auth/local`, credentials).pipe(
      tap((response: any) => {
        this.setSession(response);
      })
    );
  }

  getUser(): undefined {
    const d = localStorage.getItem('user');
    if (!d || d == "undefined") return;
    return JSON.parse(d);
  }


  private setSession(authResult: any): void {
    localStorage.setItem('token', authResult.jwt);
    localStorage.setItem('user', JSON.stringify(authResult.user));
  }

  public isAuthenticated(): boolean {
    const token = localStorage.getItem('token');
    // Optionally, you can check token expiration here
    return !!token;
  }

  logout(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }
}
